
import Vue, { PropType } from 'vue';
import format from 'date-fns/format';
import isWithinInterval from 'date-fns/isWithinInterval';
import { getVFairEventRoute } from '~/router';
import { VFairOrganization, VFairWebinar } from '~/services/VFairService';

// Components
import Pulsate from '~/components/miscellaneous/Pulsate.vue';

// Assets
import defaultBackground from '~/assets/img/vcf/event-default-bg.png';

export default Vue.extend({
    name: 'WebinarItem',
    components: { Pulsate },
    props: {
        value: {
            type: Object as PropType<VFairWebinar>,
            required: true,
        },
        vFairId: {
            type: String,
            required: true,
        },
        company: {
            type: [Object, null] as PropType<VFairOrganization>,
            default: null,
        },
        imageLeft: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        live(): boolean {
            return isWithinInterval(new Date(), {
                start: new Date(this.value.startTime),
                end: new Date(this.value.endTime),
            });
        },
        hasDuration(): boolean {
            return !!(this.value.startTime && this.value.endTime);
        },
        date(): string {
            const start = new Date(this.value.startTime);
            return format(start, 'd MMMM y');
        },
        time(): string {
            const start = new Date(this.value.startTime);
            return format(start, 'H:mm');
        },
        url(): string {
            return getVFairEventRoute(this.vFairId, this.value.id);
        },
        descriptionText(): string {
            var temp = document.createElement('div');
            temp.innerHTML = this.value.description;
            return temp.textContent || temp.innerText || '';
        },
    },
    methods: {
        getDefaultBackground(): string {
            return defaultBackground;
        },
        eventClick() {
            if (this.hasDuration) {
                let link = getVFairEventRoute(this.vFairId, this.value.id);
                this.$route.query.pavilion_id &&
                    (link += `?pavilion_id=${this.$route.query.pavilion_id}`);
                this.$router.push(link);
                return;
            }
            window.open(this.value.url);
        },
    },
});
